<form novalidate [formGroup]="userForm" (ngSubmit)="onSubmit()">
  <div class="row">
    <div class="col-12 col-md-4">
      <div class="page-header">
        Your profile
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-8 offset-md-2 col-lg-4 offset-lg-4">
      <div class="form-group">
        <mat-form-field>
          <input matInput readonly formControlName="accountNumber" placeholder="Account number">
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12" role="tablist" aria-multiselectable="true">
      <div role="tab" class="col-12 col-md-4">
        <a data-toggle="collapse" data-target="#contact-details" aria-controls="contact-details" (click)="collapseContactDetails = !collapseContactDetails"
          [attr.aria-expanded]="!collapseContactDetails">
          <p class="details-title">
            <i class="fa rotate-icon" [ngClass]="{ 'fa-angle-up':collapseContactDetails, 'fa-angle-down': !collapseContactDetails }">
            </i> My Contact details
          </p>
        </a>
      </div>

      <div id="contact-details" class="panel-collapse collapse" role="tabpanel" [ngClass]="{ 'show': !collapseContactDetails}">
        <div class="row">
          <div class="col-12 col-md-4 mx-auto">
            <div class="form-group">
              <mat-form-field>
                <mat-select formControlName="title" placeholder="Title" disabled>
                  <mat-option *ngFor="let title of titles" [value]="title.id">
                    {{title.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field>
                <input matInput formControlName="firstName" placeholder="First name" readonly>
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field>
                <input matInput formControlName="middleName" placeholder="Middle name(s) (Optional)" readonly>
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field>
                <input matInput formControlName="lastName" placeholder="Last name" readonly>
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field>
                <input matInput formControlName="email" readonly placeholder="Email address">
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field>
                <mat-select formControlName="callingCode" placeholder="Calling code" disabled>
                  <mat-select-trigger>
                    <ng-container *ngIf="!userForm.get('callingCode').value; else showCallingCode">
                      -----
                    </ng-container>
                    <ng-template #showCallingCode>
                      <span class="{{callingCodeSelect.countryCode | flagIcon}}"></span>&nbsp;
                      <span>{{callingCodeSelect.code}}</span>
                    </ng-template>
                  </mat-select-trigger>
                  <mat-option *ngFor="let callingCode of callingCodes" [value]="callingCode.id">
                    <span [class]="callingCode.code | flagIcon"></span>
                    <span>{{callingCode.code}} </span>
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class=" form-group">
              <mat-form-field>
                <input matInput formControlName="phoneNumber" placeholder="Phone number" readonly>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12" role="tablist" aria-multiselectable="true">
      <div class="col-12 col-md-4" role="tab">
        <a data-toggle="collapse" data-target="#affiliate-details" aria-controls="affiliate-details" (click)="collapseAffiliateDetails=! collapseAffiliateDetails"
          [attr.aria-expanded]="!collapseAffiliateDetails">
          <p class="details-title">
            <i class="fa rotate-icon" [ngClass]="{ 'fa-angle-up':collapseAffiliateDetails, 'fa-angle-down': !collapseAffiliateDetails }">
            </i> Partner detail
          </p>
        </a>
      </div>
      <div id="affiliate-details" class="panel-collapse collapse" role="tabpanel" [ngClass]="{ 'show':!collapseAffiliateDetails }">
        <div class="row">
          <div class="col-12 col-md-4 mx-auto">
            <div class=" form-group">
              <mat-form-field [ngClass]="{'is-valid': userForm.get('businessName').valid && userForm.get('businessName').touched}">
                <input matInput formControlName="businessName" placeholder="Business name (Optional)">
              </mat-form-field>
            </div>

            <div class=" form-group">
              <mat-form-field>
                <mat-select formControlName="accessLevel" disabled placeholder="Access level">
                  <mat-option *ngFor="let accessLevel of accessLevels" [value]="accessLevel.id">
                    {{accessLevel.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class=" form-group">
              <mat-form-field>
                <input matInput formControlName="postCode" placeholder="Post code" readonly>
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field>
                <input matInput formControlName="address1" placeholder="Address line 1" readonly>
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field>
                <input matInput formControlName="address2" placeholder="Address line 2" readonly>
              </mat-form-field>
            </div>
            <div class="form-group">
              <mat-form-field>
                <input matInput formControlName="address3" placeholder="Address line 3" readonly>
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field>
                <input matInput formControlName="city" placeholder="City" readonly>
              </mat-form-field>

            </div>
            <div class="form-group">
              <mat-form-field>
                <mat-select formControlName="country" placeholder="Country" disabled>
                  <mat-select-trigger>
                    <ng-container *ngIf="!userForm.get('country').value; else showCountry">
                      -----
                    </ng-container>
                    <ng-template #showCountry>
                      <div [innerHTML]="userForm.get('country').value | transformCountry : countrys"></div>
                    </ng-template>
                  </mat-select-trigger>
                  <mat-option *ngFor="let country of countrys" [value]="country.id">
                    <span [class]="country.code | flagIcon"></span>
                    <span>{{country.name}} </span>
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12" role="tablist" aria-multiselectable="true">
      <div class="col-12 col-md-4" role="tab">
        <a data-toggle="collapse" data-target="#bank-details" aria-controls="affiliate-details" (click)="collapseBankdetails=! collapseBankdetails"
          [attr.aria-expanded]="!collapseBankdetails">
          <p class=" details-title">
            <i class="fa rotate-icon" [ngClass]="{ 'fa-angle-up':collapseBankdetails, 'fa-angle-down': !collapseBankdetails }">
            </i> Bank detail
          </p>
        </a>
      </div>
      <div id="bank-details" class="panel-collapse collapse" role="tabpanel" [ngClass]="{ 'show':!collapseBankdetails}">
        <ng-container *ngIf="!bankId">
          <div class="add-new-bank pl-3">
            <p>Please
              <a (click)="addBankDetail()">click here</a> to add Bank account details.</p>
          </div>
        </ng-container>

        <ng-container *ngIf="bankId">
          <div class="panel-body">
            <div class="row">
              <div class="col-md-4 offset-md-2 form-group">
                <mat-form-field>
                  <input matInput formControlName="bankName" placeholder="Bank Name" readonly>
                </mat-form-field>
              </div>

              <div class="col-md-4 form-group">
                <mat-form-field>
                  <input matInput formControlName="bankCode" placeholder="Bank Code" readonly class="no-upscope">
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4 offset-md-2 form-group">
                <mat-form-field>
                  <input matInput formControlName="IBAN" placeholder="IBAN" readonly class="no-upscope">
                </mat-form-field>
              </div>

              <div class="col-md-4 form-group">
                <mat-form-field>
                  <input matInput formControlName="bankAccountNumber" placeholder="Account Number" readonly class="no-upscope">
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4 offset-md-2 form-group">
                <mat-form-field>
                  <input matInput formControlName="bankSortCode" placeholder="Sort Code" readonly class="no-upscope">
                </mat-form-field>
              </div>

              <div class="col-md-4 form-group">
                <mat-form-field>
                  <input matInput formControlName="SWIFTCode" placeholder="SWIFT Code" readonly>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4 offset-md-2 form-group">
                <mat-form-field>
                  <input matInput placeholder="Address line 1" formControlName="bankAddress1" readonly>
                </mat-form-field>
              </div>

              <div class="col-md-4 form-group">
                <mat-form-field>
                  <input matInput placeholder="Address line 2 (Optional)" formControlName="bankAddress2" readonly>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4 offset-md-2 form-group">
                <mat-form-field>
                  <input matInput placeholder="Address line 3 (Optional)" formControlName="bankAddress3" readonly>
                </mat-form-field>
              </div>

              <div class="col-md-4 form-group">
                <mat-form-field>
                  <input matInput placeholder="City" formControlName="bankCity" readonly>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 offset-md-2 form-group">
                <mat-form-field>
                  <input matInput placeholder="State/Province (Optional)" formControlName="stateProvince" readonly>
                </mat-form-field>
              </div>

              <div class="col-md-4 form-group">
                <mat-form-field>
                  <input matInput placeholder="Zip code/Postal code" formControlName="zipPostalCode" readonly>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4 offset-md-2 form-group">
                <mat-form-field>
                  <mat-select placeholder="Currency" formControlName="currency" disabled>
                    <mat-select-trigger>
                      <ng-container *ngIf="!userForm.get('currency').value; else showCurrency">
                        -----
                      </ng-container>
                      <ng-template #showCurrency>
                        <div [innerHTML]="userForm.get('currency').value | transformCurrency : currencies"></div>
                      </ng-template>
                    </mat-select-trigger>
                    <mat-option *ngFor="let currency of currencies" [value]="currency.id">
                      <span [class]="currency.code | flagIcon"></span>&nbsp;
                      <span>{{currency.code}}</span>
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="col-md-4 form-group">
                <mat-form-field>
                  <mat-select placeholder="Country" formControlName="bankCountry" disabled>
                    <mat-option *ngFor="let country of countrys" [value]="country.id">
                      {{country.name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4 offset-md-2 form-group">
                <mat-form-field>
                  <input matInput placeholder="Reference (Optional)" formControlName="reference" readonly />
                </mat-form-field>
              </div>
              <div class="col-md-4 form-group" *ngIf="isPartnerAdmin">
                <button class="btn btn-lg btn-block btn-greengo" (click)="addBankDetail()" type="button">Update</button>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12" role="tablist" aria-multiselectable="true">
      <div class="col-md-4" role="tab">
        <a data-toggle="collapse" data-target="#subcription-ref" aria-controls="subcription-ref" (click)="collapseSubRef = !collapseSubRef"
          [attr.aria-expanded]="!collapseSubRef">
          <p class="details-title">
            <i class="fa rotate-icon" [ngClass]="{ 'fa-angle-up':collapseSubRef, 'fa-angle-down': !collapseSubRef }">
            </i> Subscription preferences
          </p>
        </a>
      </div>
      <div id="subcription-ref" class="panel-collapse collapse" role="tabpanel" [ngClass]="{ 'show': !collapseSubRef}">
        <div class="ml-4">
          <mat-checkbox class="greengo break-line" disableRipple [checked]="acceptMarketingEmails" (change)="acceptMarketingEmails = !acceptMarketingEmails">Yes, I would like to be sent marketing communications and updates</mat-checkbox>
          <div class="form-group">
            <mat-checkbox class="greengo" disableRipple [checked]="acceptPolicy" (change)="acceptPolicy = !acceptPolicy">Accept {{brandName}}
              <a *ngIf="!isPrivalgoMarkets" target="_blank" rel="noopener noreferrer" href="https://www.{{domain}}/privacy-policy" class="privacy-policy">Privacy & Cookies</a>
              Policy
            </mat-checkbox>
              <div class="error-message" *ngIf="!acceptPolicy && submitForm">
                Please accept the Privacy & Cookie Policy to Proceed
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="form-group mb-2">
    <div class="row">
      <div class="col-6 col-md-2 offset-md-4">
        <button class="btn btn-lg btn-block" type="submit" [ngClass]="{
          'btn-greengo': userForm.valid && acceptPolicy,
          'btn-inactive': !userForm.valid || !acceptPolicy
        }" npFocusOutClicked>
          Update and close
        </button>
      </div>
      <div class="col-6 col-md-2 ">
        <button class=" btn w-100 btn-lead btn-lg btn-block" type="button" (click)="cancel()">Cancel</button>
      </div>
    </div>
  </div>
</form>
